import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import Modal from "react-modal";

import {
  discountValidate,
  decimalValidate,
  decimalQtyValidate,
  dateConversion,
} from "../../../../components/Validation";

import { toast } from "react-toastify";
import Select from "react-select";
import SimpleMap from "../../../../components/gmaps";

const GoodsReceiptForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const [taxs, setTaxs] = useState();
  const [currancys, setCurrancys] = useState();
  const [currancyCode, setCurrancyCode] = useState(0);
  const [discountAmt, setDiscountAmt] = useState();
  const [discountPr, setDiscountPr] = useState(0);
  const [productTotal, setProductTotal] = useState(0);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [purchaseId, setPurchaseId] = useState([]);
  const [close, setClose] = useState(false);
  const [docurl, setDocUrl] = useState(false);

  const [goodsRecieptId, setgoodsRecieptId] = useState(null);

  const [subTotalAmount, setSubTotal] = useState(0);
  const [shippinglatLong, setShippinglatLong] = useState({
    lat: 18.644040659063442,
    lng: 73.72228501488648,
  });
  const [shippingclose, setShippingclose] = useState(false);

  const [disabled, setDisabled] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);
  const [employeelist, setEmployeelist] = useState(null);

  const [loading, setLoading] = useState(false);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getTaxs } = useHttp();
  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setCurrancys(res);
        }
      }
    );
  }, [getCurrency]);

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  const { sendRequest: getPurchaseorderId } = useHttp();

  const frmRef = useRef({});
  const { sendRequest: postGoodsReceipt } = useHttp();

  useEffect(() => {
    getPurchaseorderId(
      {
        url: `/api/purchaseOrder/?orgId=${localStorage.getItem(
          "orgId"
        )}&goodreceipt=${true}`,
      },
      (res) => {
        if (res) {
          setPurchaseId(res.output);
        }
      }
    );
  }, [getPurchaseorderId]);

  const { sendRequest: getLoadVendor } = useHttp();

  const loadVendorData = (id) => {
    getLoadVendor(
      {
        url: `/api/addVendor/?vendorId=${id}`,
      },
      (res) => {
        if (res) {
          frmRef.current.contact_person_name.value =
            res.contactPersonName || "";
          frmRef.current.work_contact.value = res.contactWork || "";
          frmRef.current.whatsapp_contact.value = res.whatsapp || "";
          frmRef.current.email.value = res.email || "";
        }
      }
    );
  };

  const loadPurchaseData = (e) => {
    getPurchaseorderId(
      {
        url: `/api/purchaseOrderDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&purchaseOrderId=${frmRef.current.purchase_order_id.value}`,
      },
      (data) => {
        var poList = purchaseId.filter(
          (item) =>
            item.purchaseOrderId == frmRef.current.purchase_order_id.value
        );

        var res = poList[0];
        var purchaseOrderData = data;

        if (res) {
          console.log(res);
          loadVendorData(res.vendorId);
          frmRef.current.vendor_name.value = res.vendorName;
          frmRef.current.vendor_id.value = res.vendorId;
          frmRef.current.shipp_address.value = res.shippingAddress;
          frmRef.current.shipp_city.value = res.shippingCity;
          frmRef.current.shipp_state.value = res.shippingState;
          frmRef.current.shipp_zopcode.value = res.shippingZip;
          frmRef.current.Shipp_country.value = res.shippingCountry;

          frmRef.current.total_amt.value = parseFloat(res.totalAmount).toFixed(
            2
          );
          setProductTotal(res.totalAmount);
          frmRef.current.frieght_charges.value = parseFloat(
            res.frieghtCharges || "0"
          ).toFixed(2);
          frmRef.current.tax.value = res.taxId;
          frmRef.current.tax_amt.value = parseFloat(res.taxAmount).toFixed(2);
          frmRef.current.remark.value = res.remark;
          frmRef.current.currency.value = res.currencyId;
          setCurrancyCode(res.currencyCode);

          frmRef.current.total_cost.value = parseFloat(
            res.totalPurchase
          ).toFixed(2);
          frmRef.current.amt_chargeable.value = res.amountChargeable;
          setDiscountPr(res.discountPercentage);

          setProductDetails(
            purchaseOrderData &&
              purchaseOrderData.map((x) => ({
                ...x,
                createdBy: parseInt(localStorage.getItem("id")),
                orderAvailableQuantity: parseInt(x.orderQuantityBalance),
                lineAmount: parseInt(x.lineAmount),
                orgId: parseInt(localStorage.getItem("orgId")),
                goodsReceiptQuantity: parseInt(x.orderQuantity),
                expiryDate: "",
                goodsReceiptQuantityBalance: parseInt(x.orderQuantityBalance),
              }))
          );

          // //console.log("purchaseOrderData", purchaseOrderData);

          setSubTotal(parseFloat(res.lineTotalAmount).toFixed(2));

          setDiscountAmt(res.discountAmount);
          // productRef.current.discountAmount.value = res.discountAmount;

          productRef.current.discount.value = res.discountPercentage;

          // //console.log(res.vendorId);
          shippinglatLong(
            res.shippinglatLong || {
              lat: 18.644040659063442,
              lng: 73.72228501488648,
            }
          );
        }
      }
    );
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (productDetails.length === 0) {
      toast.error("Please add at least one product.");
      return;
    }

    var taxId = frmRef.current.tax.value;
    var taxPercentage = 0;
    if (taxId != "Select Tax") {
      var selectedTax = taxs.filter((item) => item.taxId == taxId);
      taxPercentage = selectedTax && selectedTax[0].taxPercentage;
    }
    var expBlank = false;
    productDetails.forEach((item) => {
      if (item.expiryDate != "") {
        item.expiryDate = dateConversion(
          item.expiryDate,
          "YYYY-MM-DD",
          "DD/MM/YYYY"
        );
      } else {
        expBlank = true;
      }

      var stockAmount = 0;
      stockAmount = item.lineAmount;
      // //console.log("stockAmount", stockAmount);
      // //console.log("discountPr", discountPr);

      if (parseFloat(discountPr) > 0) {
        var linedisAmount = (item.lineAmount * parseFloat(discountPr)) / 100;
        linedisAmount = linedisAmount.toFixed(2);
        // //console.log("linedisAmount", linedisAmount);

        stockAmount = (item.lineAmount - linedisAmount).toFixed(2);
      }

      if (parseFloat(taxPercentage) > 0) {
        var linetaxamount = (stockAmount * parseFloat(taxPercentage)) / 100;
        linetaxamount = linetaxamount.toFixed(2);
        //  //console.log("linetaxamount", linetaxamount);

        stockAmount = parseFloat(stockAmount) + parseFloat(linetaxamount);
      }
      item["stockAmount"] = stockAmount;
      //console.log("stockAmount", stockAmount);
    });

    if (expBlank) {
      toast.error("Please enter expiry date.");
      setClose(true);
      return;
    }
    // //console.log("productDetails", productDetails);

    setLoading(true);
    const data = {
      goodsReceiptDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),

      purchaseOrderId: frmRef.current.purchase_order_id.value,

      vendorId: frmRef.current.vendor_id.value,
      contactPersonName: frmRef.current.contact_person_name.value,

      productDetails: productDetails,
      lineTotalAmount: subTotalAmount,
      freightCharges: frmRef.current.frieght_charges.value,
      discountPercentage: discountPr,
      discountAmount: ((discountPr * subTotalAmount) / 100).toFixed(2),

      taxId: frmRef.current.tax.value,
      taxAmount: parseFloat(frmRef.current.tax_amt.value).toFixed(2),
      totalPurchaseAmount: parseFloat(frmRef.current.total_cost.value).toFixed(
        2
      ),
      totalAmount: frmRef.current.total_amt.value,
      amountChargeable: frmRef.current.amt_chargeable.value,
      currencyId: frmRef.current.currency.value,
      exchangeRate: frmRef.current.exchange_rate.value || 0,
      recievedBy: employeeId,
      supervisorEmployeeId: employeeId,
      deliveredBy: frmRef.current.delivered_by.value,
      status: 1,
      remark: frmRef.current.remark.value,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    // //console.log(data);
    if (props.update) {
      data["goodsRecieptId"] = props.update.goodsRecieptId;
    }

    postGoodsReceipt(
      {
        url: "/api/goodsReciept/",
        method: props.update ? "PUT" : "POST",
        // method:"POST",
        body: data,
      },
      (res) => {
        toast.success(`Good Receipt ${props.update ? "Updated" : "Added"}`);
        setgoodsRecieptId(res.goodsRecieptId);
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      setDisabled(true);

      frmRef.current.date.value = props.update.goodsReceiptDate;
      loadVendorData(props.update.vendorId);
      //setPurchaseId(props.update.purchaseorderId]);
      frmRef.current.purchase_order_id.value = props.update.purchaseorderId;
      frmRef.current.vendor_name.value = props.update.vendorName;
      frmRef.current.vendor_id.value = props.update.vendorId;
      loadPurchaseData();

      frmRef.current.total_amt.value = props.update.totalAmount;

      frmRef.current.frieght_charges.value = props.update.frieghtCharges;
      frmRef.current.tax.value = props.update.taxId;
      frmRef.current.tax_amt.value = props.update.taxAmount;
      frmRef.current.total_cost.value = props.update.totalPurchase;
      frmRef.current.amt_chargeable.value = props.update.amountChargeable;
      frmRef.current.remark.value = props.update.remark;
      // frmRef.current.received_by.value = props.update.recievedBy;
      setProductDetails(props.update.productDetails);
      setgoodsRecieptId(props.update.goodsRecieptId);
      setShippinglatLong(
        props.update.shippinglatLong || {
          lat: 18.644040659063442,
          lng: 73.72228501488648,
        }
      );
    }
  }, [props.update]);

  useEffect(() => {
    if (close) {
      setTotalValue();
    }
  }, [productDetails]);

  const setTotalValue = () => {
    let acc = 0;
    productDetails.forEach((x) => {
      acc += x.rate * x.orderQuantity;
    });

    setSubTotal(acc.toFixed(2));
  };

  const viewPdf = (e) => {
    e.preventDefault();
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
  };

  useEffect(() => {
    const OrgCurrancy = localStorage.getItem("currencyCode");
    const exchangeRateLabel = frmRef.current.exchange_rate_label;
    const exchangeRateInput = frmRef.current.exchange_rate;

    if (OrgCurrancy === currancyCode) {
      exchangeRateLabel.style.display = "none";
      exchangeRateInput.style.display = "none";
    } else {
      exchangeRateLabel.style.display = "block";
      exchangeRateInput.style.display = "block";
    }
  }, [currancyCode]);

  return (
    <>
      {shippingclose && (
        <Modal onClose={setShippingclose}>
          <SimpleMap
            lat={shippinglatLong.lat}
            lng={shippinglatLong.lng}
            set={setShippinglatLong}
            close={setShippingclose}
          />
        </Modal>
      )}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <div className="">
            <table className="table table-responsive table-bordered">
              <thead>
                <tr className="tableheaderrowview">
                  <th>Sr.No</th>
                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Type</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                  <th>Expiry Date</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.linesrNo}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.orderQuantity}</td>
                        <td>{itm.unitName}</td>
                        <td>{itm.lineAmount}</td>
                        <td>
                          <input
                            type={"date"}
                            id={"date"}
                            required
                            defaultValue={itm.expiryDate}
                            ref={(el) =>
                              (productRef.current["expiryDate"] = el)
                            }
                            className="form-control"
                            min={selectedDate}
                            onChange={(e) => {
                              //  //console.log("i", i);

                              productDetails[i].expiryDate = e.target.value;
                              // //console.log(
                              //   "productDetails[i].expiryDate",
                              //   productDetails[i]
                              // );
                              setProductDetails([...productDetails]);
                              // //console.log("productDetails", productDetails);
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <hr />
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"subTotalAmount"}>Sub-total Amount</label>
              <input
                type={"number"}
                id={"subTotalAmount"}
                value={subTotalAmount}
                ref={(el) => (productRef.current["subTotalAmount"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discount"}>Discount%</label>
              <input
                type={"number"}
                id={"discount"}
                required
                value={discountPr}
                onChange={(e) => {
                  const disc =
                    (e.target.value * productRef.current.subTotalAmount.value) /
                    100;

                  disc = disc.toFixed(2);

                  productRef.current.discountAmount.value = disc;

                  productRef.current.totalAmount.value =
                    productRef.current.subTotalAmount.value - parseFloat(disc);
                }}
                ref={(el) => (productRef.current["discount"] = el)}
                className="form-control"
                disabled
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discountAmount"}>Discount Amount</label>
              <input
                type={"number"}
                id={"discountAmount"}
                required
                disabledd
                ref={(el) => (productRef.current["discountAmount"] = el)}
                className="form-control"
                disabled
                //value={discount}
                value={discountAmt}
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"totalAmount"}>Total</label>
              <input
                type={"input"}
                id={"totalAmount"}
                required
                ref={(el) => (productRef.current["totalAmount"] = el)}
                value={productTotal}
                className="form-control"
                disabled
              />
            </div>
          </div>

          <div className="text-center mt-3">
            {" "}
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails &&
                  productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Goods Reciept Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"purchase_order_id"}>
                        {"Purchase Order No"}
                      </label>
                      <select
                        // id="purchase_order_id"
                        className="form-control dropdowns"
                        required
                        ref={(el) => (frmRef.current["purchase_order_id"] = el)}
                        onChange={loadPurchaseData}
                      >
                        <option value="">Select</option>

                        {purchaseId &&
                          purchaseId.map((x, i) => (
                            <option key={i} value={x.purchaseOrderId}>
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"received_by"}>{"Received by"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["received_by"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option value={""}>Select</option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_name"}> {"Vendor Name"}</label>
                      <input
                        type={"text"}
                        disabled
                        id="vendor_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                        // onChange={()=>handleVendorChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"vendor_id"}> {"Vendor Id"}</label>
                      <input
                        type={"text"}
                        id={"vendor_id"}
                        required
                        disabled
                        ref={(el) => (frmRef.current["vendor_id"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>
                        {"Contact Number(work)"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"whatsapp_contact"}>
                        {"Contact Number(whatsapp)"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_contact"}
                        required
                        ref={(el) => (frmRef.current["whatsapp_contact"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Shipping Address"}>
                        {"Shipping Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_address"}
                        required
                        ref={(el) => (frmRef.current["shipp_address"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"shipp_city"}
                        required
                        ref={(el) => (frmRef.current["shipp_city"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_state"}>
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_state"}
                        required
                        ref={(el) => (frmRef.current["shipp_state"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"shipp_zopcode"}>
                        {" Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_zopcode"}
                        required
                        ref={(el) => (frmRef.current["shipp_zopcode"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Shipp_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"Shipp_country"}
                        required
                        ref={(el) => (frmRef.current["Shipp_country"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter(
                                (x) => x.isSave || x.purchaseOrderDetailId
                              )
                            );
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control currancy-value"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"frieght_charges"}>
                        {"Frieght Charges"}
                      </label>
                      <input
                        type={"text"}
                        id={"frieght_charges"}
                        required
                        ref={(el) => (frmRef.current["frieght_charges"] = el)}
                        className="form-control currancy-value"
                        disabled
                      />
                    </div>{" "}
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        disabled
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control currancy-value"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control currancy-value"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}> {"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["currency"] = el)}
                        disabled
                      >
                        {currancys &&
                          currancys.map((x) => (
                            <option key={x.currencyId} value={x.currencyId}>
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label
                        htmlFor={"exchange_rate"}
                        ref={(el) =>
                          (frmRef.current["exchange_rate_label"] = el)
                        }
                      >
                        {" "}
                        {"Exchange Rate"}
                      </label>
                      <input
                        type={"text"}
                        id={"exchange_rate"}
                        defaultValue={0}
                        required
                        ref={(el) => (frmRef.current["exchange_rate"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"delivered_by"}> {"Delivered by"}</label>
                      <input
                        type={"text"}
                        id={"delivered_by"}
                        required
                        ref={(el) => (frmRef.current["delivered_by"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GoodsReceiptForm;
